import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import DxDiagnosisListForm from '@src/features/company/dx-diagnosis/DxDiagnosisListForm';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyDxDiagnosisList() {
  return (
    <CompanyGuard
      canRoles={[COMPANY_ROLE.ADMIN]}
      canService={[SERVICE.DX_DIAGNOSIS]}
    >
      <CompanyDefaultLayout pageName='dx-diagnosis'>
        <CommonHelmet />
        <DxDiagnosisListForm />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyDxDiagnosisList;
